import { useState } from "react"
import { EquipmentImage } from "./EquipmentImage"
import { Button, Col, Row, Space, Table } from "antd"
import { FlowNozzleShape, SimiulatorEquipment, SimulatorNozzle } from "@/types/equipment"
import { nozzleTypeToText, toNozzleDirectionText } from "@/common/filter"
import styles from "./image.module.less";
import { AttributeEditor } from "./AttributeEditor"
import { useOutletContext } from "react-router-dom"
import { AddEditNozzle } from "./AddEditNozzle"
import { deleteNozzleFromEquipment, updateEquipmentNozzle } from "@/services/project/equipment/equipment.service"
import { GraphAttributes } from "@/types/common"
import { LayoutEditorContext } from "./LayoutEditorContext"

export const GraphDesign = () => {
  const [equipment, refreshEquipment] = useOutletContext<[SimiulatorEquipment, Function]>();
  const [currentNozzle, setCurrentNozzle] = useState<SimulatorNozzle | null>(null)
  const [layout, setLayout] = useState<GraphAttributes | null>()

  const changeNozzleGraph = (changes = {}) => {
    
    setLayout({ ...layout!, ...changes })
  }

  const selectedNozzle = (nozzle) => {
    const target = equipment.nozzles.find(item => item.id === nozzle.id)!
    setCurrentNozzle(target)
    setLayout(nozzle.customLayout)
  }

  const savePosition = () => {
    const {name, type, shape, direction} = currentNozzle!
    const nozzle = { name, type, shapeId: shape?.id, direction }
    updateEquipmentNozzle({...nozzle, customLayout: layout}, {id: currentNozzle!.id, equipmentId: equipment.id})
    refreshEquipment()
  }

  const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
    render: (type) => {
      return nozzleTypeToText(type)
    }
  },
  {
    title: 'Direction',
    dataIndex: 'direction',
    key: 'direction',
    render: (direction) => {
      return toNozzleDirectionText(direction)
    }
  },
  {
    title: 'Shape',
    dataIndex: 'shape',
    key: 'shape',
    render: (shape?: FlowNozzleShape) => {
      return shape?.name || '-';
    }
  },
  {
    title: 'Actions',
    key: 'action',
    render: (nozzle: SimulatorNozzle) => {
      return <Space>
        <Button onClick={async () => {
          AddEditNozzle.show({equipment, nozzle, onSuccess: () => {
            refreshEquipment()
          }})
        }}>Edit</Button>
        <Button onClick={async () => {
          await deleteNozzleFromEquipment(equipment.id, nozzle.id)
          refreshEquipment()
        }}>Delete</Button>
      </Space>
    }
  },
];

  return <div>
    <LayoutEditorContext.Provider value={{
      layout,
      nozzleId: currentNozzle?.id,
      selectedNozzle
    }}>
    <Row>
      <Col>
        <EquipmentImage equipment={equipment} />
      </Col>
      {currentNozzle?.customLayout && <Col flex={'auto'}>
        <div className={styles.imageControls}>
          <h3>Nozzle</h3>
          <AttributeEditor value={layout?.x || 0} step={0.02} min={-1} max={1.5} title={'Left'} onChange={(val) => {
            changeNozzleGraph({ x: val })
          }} />
          <AttributeEditor value={layout?.y || 0} step={0.02} min={-1} max={1.5} title={'Top'} onChange={(val) => {
            changeNozzleGraph({ y: val })
          }} />
          {currentNozzle.shape?.svg && <AttributeEditor value={layout?.width || 0} min={10} max={30} title={'Width'} onChange={(val) => {
            changeNozzleGraph({ width: val })
          }} />}
          {currentNozzle.shape?.svg && <AttributeEditor value={layout?.height || 0} min={10} max={30} title={'Height'} onChange={(val) => {
            changeNozzleGraph({ height: val })
          }} />}
          {currentNozzle.shape?.svg && <AttributeEditor value={layout?.angle || 0} min={0} max={360} title={'Angle'} onChange={(val) => {
            changeNozzleGraph({ angle: val })
          }} />}
        </div>
        <div><Button onClick={savePosition}>Save Position</Button></div>
      </Col>}
    </Row>
    </LayoutEditorContext.Provider>
    <div>
      <h3>Nozzles</h3>
      <div className="actionRow">
        <Button type='primary' onClick={() => {
          AddEditNozzle.show({equipment, onSuccess: () => {
            refreshEquipment()
          }})
        }}>Add Nozzle</Button>
      </div>
      <Table
        size="small"
        pagination={false}
        columns={columns}
        dataSource={equipment.nozzles}
        className="table"
        rowKey='id' />
    </div>
  </div>
}